// import ACTION_TYPES from 'profilePage/actions/actionTypes';

export default function pageOptionsReducer(state = {}, resp) {
  return state;
}
